import { createSlice } from "@reduxjs/toolkit";

interface NotificationState {
  shouldRefetch: boolean;
}

const initialState: NotificationState = {
  shouldRefetch: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    triggerRefetch(state) {
      state.shouldRefetch = true;
    },
    resetRefetch(state) {
      state.shouldRefetch = false;
    },
  },
});

export const { triggerRefetch, resetRefetch } = notificationSlice.actions;
export default notificationSlice.reducer;